import { useContext, useEffect, useState } from 'react';

import { ReloadOutlined } from '@ant-design/icons';
import {
	Button,
	Checkbox,
	Flex,
	Input,
	Space,
	Spin,
	Table,
	Tooltip,
} from 'antd';
import { Tabs } from 'antd/lib';
import { useNavigate } from 'react-router-dom';

import { SubscriptionContext } from '@/App';
import { useGetAllCopilotVideos } from '@/api/batch_process';
import MultiButton from '@/components/common/MultiButton';
import AddCreatorToCollectionModal from '@/components/modals/AddCreatorToCollectionModal';
import AddVideoToCollectionModal from '@/components/modals/AddVideoToCollectionModal';
import { SUBSCRIPTIONS_TYPES_ENUM } from '@/const';
import { useDebounce } from '@/hooks';
import hasSubscriptionType from '@/lib/helpers/hasSubscriptionType';
import { PageContext } from '@/providers/PageContextProvider';

import { IPagination } from '../video-intelligence-on-demand';
import CopilotBatch from './CopilotBatch';
import CopilotSingleVideos from './CopilotSingleVideos';
import FiltersSection from './FiltersSection';

export default function VideoInsightsCoPilot() {
	const [activeKey, setActiveKey] = useState('single-videos');
	const navigate = useNavigate();
	const { subscriptions, subscriptionLoading } =
		useContext(SubscriptionContext);
	const { setPageTitle, setIsCopilotCreditsCounterVisible } =
		useContext(PageContext);
	const [appliedData, setAppliedData] = useState<any>(null);
	const [isPanelOpen, setIsPanelOpen] = useState(false);

	useEffect(() => {
		setPageTitle('Video insights co-pilot');
		setIsCopilotCreditsCounterVisible(true);

		return () => {
			setPageTitle('');
			setIsCopilotCreditsCounterVisible(false);
		};
	}, []);

	useEffect(() => {
		if (!subscriptionLoading && subscriptions && subscriptions?.length > 0) {
			if (
				!hasSubscriptionType(subscriptions, SUBSCRIPTIONS_TYPES_ENUM.copilot)
			) {
				navigate('/app/dashboard/product-main-menu');
			}
		} else if (
			!subscriptionLoading &&
			subscriptions &&
			subscriptions?.length === 0
		) {
			navigate('/app/dashboard/product-main-menu');
		}
	}, [subscriptions, subscriptionLoading]);

	return (
		<>
			<Flex
				align="center"
				justify="space-between"
				style={{ marginBottom: '1.5rem' }}
			>
				<h2>Copilot videos history</h2>
			</Flex>

			<Flex vertical gap={16} style={{ width: '100%' }}>
				<Flex
					gap={16}
					justify="flex-end"
					align="center"
					style={{ width: '100%' }}
				>
					<Button
						onClick={() => {
							navigate('/app/dashboard/video-insights-co-pilot/collections');
						}}
					>
						Collections
					</Button>

					<Button onClick={() => setIsPanelOpen((prev) => !prev)}>
						{isPanelOpen ? 'Hide' : 'Show'} Q&A panel
					</Button>
				</Flex>

				<FiltersSection
					key={appliedData?.id || 'filters-section-component'}
					isOpen={isPanelOpen}
					data={appliedData}
					clearData={() => setAppliedData(null)}
				/>
			</Flex>
			<Tabs
				activeKey={activeKey}
				items={[
					{
						key: 'single-videos',
						label: 'Single videos',
						children: <CopilotSingleVideos />,
					},
					{
						key: 'batches',
						label: 'Batches',
						children: <CopilotBatch />,
					},
				]}
				onChange={(key) => setActiveKey(key)}
			/>
			<AddVideoToCollectionModal />
			<AddCreatorToCollectionModal />
		</>
	);
}
